import { Component, OnDestroy } from '@angular/core';

import { IUserTag } from './IUserTag';
import { VideoUserTagsService } from './VideoUserTags.Service';

@Component({
	selector: 'in-this-video',
	templateUrl: './InThisVideo.Component.html'
})
export class InThisVideoComponent implements OnDestroy {

	constructor(
		public VideoUserTags: VideoUserTagsService
	) { }

	public ngOnDestroy(): void {
		this.VideoUserTags.clearActiveUserTag();
	}

	public onEntryToggle(tag: IUserTag): void {
		this.VideoUserTags.toggleActiveUserTag(tag);
	}
}
